/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { EpsiOrderDetailResponse } from '../types/EpsiOrderDetail';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type EpsiOrdersRetrieveRequest = {} | null | undefined;
export type EpsiOrdersRetrieveResponse = EpsiOrderDetailResponse;

export type EpsiOrdersRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this epsi order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/epsi_orders/{id}/
 *
 * ```yaml
 * operationId: epsi_orders_retrieve
 * tags:
 *   - epsi_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/EpsiOrderDetail'
 *     description: ''
 * ```
 */
export const epsiOrdersRetrieveOperation = ({ id, ...rest }: EpsiOrdersRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/epsi_orders/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/epsi_orders/{id}/' };
  };

/**
 * GET /dmx-server/epsi_orders/{id}/
 *
 * ```yaml
 * operationId: epsi_orders_retrieve
 * tags:
 *   - epsi_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/EpsiOrderDetail'
 *     description: ''
 * ```
 */
export const epsiOrdersRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: EpsiOrdersRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<EpsiOrderDetailResponse>> => {
  const operation = epsiOrdersRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/epsi_orders/{id}/
 */
export const useEpsiOrdersRetrieveResource = (
  query: EpsiOrdersRetrieveQuery | null,
  useCached?: boolean,
): UseResource<EpsiOrdersRetrieveResponse> => {
  return useResource<EpsiOrdersRetrieveResponse>({
    path: query === null ? null : epsiOrdersRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
